import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Sign Out
 */
export default function SignOutIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path d="M6 3.2c0.22 0 0.4 -0.18 0.4 -0.4s-0.18 -0.4 -0.4 -0.4h-2c-1.325 0 -2.4 1.075 -2.4 2.4v6.4c0 1.325 1.075 2.4 2.4 2.4h2c0.22 0 0.4 -0.18 0.4 -0.4s-0.18 -0.4 -0.4 -0.4h-2c-0.882 0 -1.6 -0.718 -1.6 -1.6V4.8c0 -0.882 0.718 -1.6 1.6 -1.6zm8.283 5.083c0.155 -0.155 0.155 -0.41 0 -0.565l-3.6 -3.6c-0.155 -0.155 -0.41 -0.155 -0.565 0s-0.155 0.41 0 0.565L13.035 7.6H6c-0.22 0 -0.4 0.18 -0.4 0.4s0.18 0.4 0.4 0.4h7.035L10.117 11.318c-0.155 0.155 -0.155 0.41 0 0.565s0.41 0.155 0.565 0z" />
    </Icon>
  );
}
